export default {

    namespaced : true,
    
      state : {
  
          client : null,
          planner : null,
  
      plannerViaAdmin : null,
  
      },
  
    mutations: {
  
      setClient(state, client) {
        state.client = client;
      },
  
      setPlanner(state, planner) {
        state.planner = planner;
      },
  
      setPlannerProperty(state, property) {
        state.planner[property.key] = property.value
      },
  
      // Planner via admin is the planner that an admin is currently looking at
      // This is necessary because in Site Appearance page, the desktop header
      // must update according to the planner's site appearance being changed
      setPlannerViaAdmin(state, planner) {
        state.plannerViaAdmin = planner
      },
  
      setPlannerViaAdminProperty(state, property) {
        state.plannerViaAdmin[property.key] = property.value
      },

  
    },
  
  }